























































































































































































import Vue, { PropType } from 'vue';
import axios from 'axios';

import store from "@/store";
import ReviewCard from '@/parts/util/ReviewCard.vue';
import AdBanner from '@/parts/util/AdBanner.vue';
import HelperTooltip from '@/parts/common/HelperTooltip.vue';
import SimpleTooltip from '@/parts/util/SimpleTooltip.vue';
import { getDaysCountToEndDate } from '@/utils/momentUtils';
import { getUserNickName } from '@/utils/labelUtils';
import TenderSituationModal from "@/parts/tender/TenderSituationModal.vue";
import MessageModal from "@/parts/util/MessageModal.vue";
import Editor from '@/parts/review/Editor.vue';
import { ErrorResponse } from '@/api/dto/Error';
import { Skill } from '@/api/dto/Skill';

import moment from "moment";

import { ReviewRecommendResponse, ReviewResponse } from '@/api/dto/Review';
import { getReview, getRecommendReviews, updateReviewStatus } from '@/api/Review';
import { UserProfile } from '@/api/dto/UserProfile';
import { defaultIconUrl } from '@/properties';
import { Completed, Confirmation, Draft, InReview, Pending } from '@/api/dto/DealStatus';

export default Vue.extend({
  name: 'Review',
  components: {
    Editor,
    ReviewCard,
    AdBanner,
    HelperTooltip,
    TenderSituationModal,
    MessageModal,
    SimpleTooltip,
  },
  props: {
    loginData: Object as PropType<UserProfile>,
    logged: Boolean, // ログイン状態
  },
  data() {
    return {
      defaultIconUrl,
      reviewData: {} as ReviewResponse,
      reviewRecomendData: [] as ReviewRecommendResponse[],
      receiveModal: false,
      /** 入札状況モーダルの表示フラグ */
      visibleTenderSituationModal: false,
      isEnlarge: false,
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      store.dispatch('updateAuth');
      // レビュー取得
      const res = await getReview(to.params.dealId);
      var access = false;
      switch(res.dealStatus) {
        case '1':
          // 依頼者がログイン者である
          if(res.purchaseUserId == store.getters.userProfile.userId){
            access = true;
          }
          break;
        case '2':
        case '3':
        case '4':
        case '5':
          access = true;
          break;
      }

      // 閲覧権限のチェック
      switch (res.viewPermission) {
        case '1':
          access = true;
          break;
        case '2':
        case '3':
          // 依頼者がログイン者である
          if(res.purchaseUserId == store.getters.userProfile.userId){
            access = true;
            break;
          }
          // 承認権限ユーザの場合
          if( store.getters.userProfile.corporateUserCategory == '1') {
            access = true;
            break;
          }

          let param = location.search;
          if (param.includes("fromMail") || store.getters.userProfile.userCategory == '4' || res.dealStatus == '5') {
            access = true;
            break;
          } else {
            next(vm => {
              vm.$emit('errorToast', 'この依頼の閲覧権限がありません。');
              vm.$router.push({ name: "Top" });
            })
          }
      }

      if(access){
        next(vm => vm.$data.reviewData = res);
      } else {
        next({ name: 'Top' });
      }
    } catch (e) { // APIエラー、依頼が存在しない場合
      next({ name: 'Top' });
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      // レビュー取得
      const res = await getReview(to.params.dealId);
      var access = false;
      switch(res.dealStatus) {
        case '1':
          // 依頼者がログイン者である
          if(res.purchaseUserId == this.getLoginData.userId){
            access = true;
          }
          break;
        case '2':
        case '3':
        case '4':
        case '5':
          access = true;
          break;
      }
      if(access){
        this.reviewData = res;
        next();
        this.reviewRecomendData = [];
        this.fetchRecommendedReviews();
      } else {
        next({ name: 'Top' });
      }
    } catch (e) { // APIエラー、依頼が存在しない場合
      next({ name: 'Top' });
    }
  },
  mounted() {
    // メールから依頼を開くときはログインデータの反映がされていないことがあるため、再度アクセス可能なユーザかチェック
    let param = location.search;
    if (param.includes("fromMail")) {
      this.accessDetail();
    }
    this.fetchRecommendedReviews();
  },
  computed: {
    getLoginData(): UserProfile {
      return this.loginData ? this.loginData : this.$store.getters.userProfile;
    },
    formattedPurchaseOverview(): string {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.purchaseOverview ? this.reviewData.purchaseOverview.replace(urlRegex, (url: string) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
      }) : '';
    },
    formattedCodeEditor(): {} {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.codeEditor ? this.reviewData.codeEditor.map((item) => {
        return {
          ...item,
          remarks: item.remarks.replace(urlRegex, (url: string) => {
            return `<a href="${url}" target="_blank">${url}</a>`;
          })
        }
      }) : {};
    },
    /** レビューの受注方式が入札かどうか */
    isPurchaseTypeTender(): boolean {
      return this.reviewData.purchaseType === '1';
    },
    /** 掲載期限切れかどうか */
    isExpired(): boolean {
      const now = moment();
      return now.isAfter(moment(this.reviewData.publishedPeriod, "YYYY/MM/DD HH:mm:ss"))
    },
    /** 入札上限に到達しているかどうか*/
    isTenderLimit(): boolean {
      if (this.reviewData.limitCount == null || this.reviewData.limitCount == 0) {
        return false;
      } else if (this.reviewData.tenderCount >= this.reviewData.limitCount) {
        return true;
      } else {
        return false;
      }
    },
   /**
    * 入札者数が0か1人以上かを判定する
    */
    tenderExists() {
      if(this.reviewData.tenderCount > 0) {
        return false;
      } else {
        return true;
      }
    },
    /**  ステータスに応じた文言 */
    statusLabel(): string {
      switch (this.reviewData.dealStatus) {
        case InReview:
          return "レビュー中";
        case Confirmation:
          return "確認中";
        case Completed:
          return "このレビューは完了しました";
        default:
          return "";
      }
    },
    /**
     * 入札状況を表示するかどうか
     * NOTE: 以下の条件に該当で表示
     *      ・依頼方法が「入札」
     *      ・取引ステータスが「1: 下書き、期限切れ 」or「1: 受注待ち」
     */
    visibleTenderSituation(): boolean {
      return (
        this.isPurchaseTypeTender &&
        [Draft, Pending].includes(this.reviewData.dealStatus)
      );
    },
    /**
     * 必須スキルを表示するかどうか
     */
    visibleOrderSkills(): boolean {
      return !!this.reviewData.orderSkills;
    },
    nickname(): string {
      return getUserNickName(this.reviewData.purchaseNickname, this.reviewData.purchaseUserId);
    },
    isEnlarged():boolean {
      return this.isEnlarge;
    }
  },
  methods: {
    // レビュー取得（おすすめ_関連）
    async fetchRecommendedReviews() {
      try {
        const reviews = await getRecommendReviews(this.reviewData.language);
        this.reviewRecomendData = reviews.filter((v: ReviewRecommendResponse) => (v.dealId != this.reviewData.dealId)).slice(0,5);
      } catch (e) {
        console.log(e);
      }
    },
    async orderExt() {
      try {
        await updateReviewStatus(this.reviewData.dealId, {
          dealStatus: '3', orderUserId: this.getLoginData.userId,
        });
        this.$router.push({name: 'Deal', params: { dealId: this.reviewData.dealId }});
      } catch (e) {
        console.error(e)
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit('errorToast', '受注の開始に失敗しました。時間をおいて再度お試しください。');
          } else {
            this.$emit('errorToast', resError.message);
            this.$router.push({ name: "Top" });
          }
        }
      } finally {
        this.receiveModal = false;
      }
    },
    /**
     * この依頼に入札する or 入札内容を変更する click ハンドラ
     */
     async handleClickTender() {
      // 未ログインの場合、ログイン画面へ遷移
      if(!this.logged){
        this.onPushPath("/login");
        return;
      }
      // アカウント制限の場合、トップに遷移
      await this.$store.dispatch('updateAccountStatusAndIconUrlInSession');
      if(this.getLoginData.accountStatus == '3') {
        this.$emit('errorToast', 'アカウント制限中のため、依頼に入札できません。');
        this.$router.push({name:'Top'});
        return;
      }
      // 期限切れの場合は遷移しない
      if(this.isExpired){
        return;
      }
      // 受注必須スキルのレベルが満たない場合は遷移しない
      const orders = this.reviewData.orderSkills as Skill[];
      if (orders != null) {
        for (let i = 0; i < orders.length; ++i) {
          // 言語
          const filter1 = this.getLoginData.skill.language.filter(v => v.name == orders[i].skillName);
          const filter2 = filter1.filter(v => v.exp >= orders[i].level);
          // 技術
          const filter3 = this.getLoginData.skill.tool.filter(v => v.name == orders[i].skillName);
          const filter4 = filter3.filter(v => v.exp >= orders[i].level);

          if ((filter2.length + filter4.length) == 0) {
            this.$emit('errorToast', '受注必須スキルのレベルが足りていないため、受注できません。');
            return;
          }
        }
      }

      this.$router.push({
        name: this.reviewData.isTender ? 'EditTenderSettings' : 'CreateTenderSettings',
        params: { dealId: this.reviewData.dealId }
      })
    },
    /**
     * この依頼を受注する
     */
    async handleClickOrder() {
      // 未ログインの場合、ログイン画面へ遷移
      if(!this.logged){
        this.onPushPath("/login");
        return;
      }
      // アカウント制限の場合、トップに遷移
      await this.$store.dispatch('updateAccountStatusAndIconUrlInSession');
      if(this.getLoginData.accountStatus == '3') {
        this.$emit('errorToast', 'アカウント制限中のため、依頼を受注できません。');
        this.$router.push({name:'Top'});
        return;
      }
      this.receiveModal = true;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
    /** 拡大縮小を切り替える */
    changeEnlargeFlag() {

      // margin-topの値を変更する
      let editStyle = (className:string,value:string) => {
        let subReviewDetails = document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>;
        Array.prototype.forEach.call(subReviewDetails,(item)=>{
          item.style.marginTop = value;
        })
      }; 

      // クラスを追加する
      let addClass = (className:string,addName:string) => {
        Array.prototype.forEach.call(document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>,(item)=>{
          item.classList.add(addName);
        })
      };

      // クラスを削除する
      let removeClass = (className:string,removeName:string) => {
        Array.prototype.forEach.call(document.getElementsByClassName(className) as HTMLCollectionOf<HTMLElement>,(item)=>{
          item.classList.remove(removeName);
        })
      };

      
      if (this.isEnlarge) { // 拡大中のときの処理
        document.getElementById("detail-contents")!.style.display = "flex";
        editStyle("sub-review-detail","0px");
        removeClass("outline","enlarge-outline");
        removeClass("sub-column","enlarge-sub-column");
        removeClass("order-user","enlarge-order-user");
        removeClass("buttons","enlarge-buttons");
        removeClass("conditions","enlarge-conditions");
        editStyle("order-user","30px");
        this.isEnlarge = false;
      } else { // 拡大していないときの処理
        document.getElementById("detail-contents")!.style.display = "block";
        editStyle("sub-review-detail","30px");
        addClass("outline","enlarge-outline");
        addClass("sub-column","enlarge-sub-column");
        addClass("order-user","enlarge-order-user");
        addClass("buttons","enlarge-buttons");
        addClass("conditions","enlarge-conditions");
        editStyle("order-user","0px");
        this.isEnlarge = true;
      }
    },
    copyUrl() {
      let url = location.href;
      navigator.clipboard.writeText(url);
      this.$emit('toast', '共有リンクをコピーしました。');
    },
    /**
     * 権限をチェックし、アクセスできるか出来ないかを判定する
     */
    accessDetail() {
      try {
      // レビュー取得
      var access = false;
      switch(this.reviewData.dealStatus) {
        case '1':
          // 依頼者がログイン者である
          if(this.reviewData.purchaseUserId == this.$store.getters.userProfile.userId){
            access = true;
          }
          break;
        case '2':
        case '3':
        case '4':
        case '5':
          access = true;
          break;
      }

      // 閲覧権限のチェック
      switch (this.reviewData.viewPermission) {
        case '1':
          access = true;
          break;
        case '2':
        case '3':
          // 依頼者がログイン者である
          if(this.reviewData.purchaseUserId == this.$store.getters.userProfile.userId){
            access = true;
            break;
          }

          // 承認権限ユーザの場合
          if(store.getters.userProfile.corporateUserCategory == '1') {
            access = true;
            break;
          }

          if (store.getters.userProfile.userCategory == '4' || this.reviewData.dealStatus == '5') {
            access = true;
            break;
          } else {
              this.$emit('errorToast', 'この依頼の閲覧権限がありません。');
              this.$router.push({ name: "Top" });
          }
      }

      if(!access){
        this.$router.push({ name: 'Top' });
      }
    } catch (e) { // APIエラー、依頼が存在しない場合
      this.$router.push({ name: 'Top' });
    }
}
  },
  filters: {
    amountLocaleString: function(amount: number) {
      if(amount){
        return amount.toLocaleString();
      } else { // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
    remainingDays(period: string): string {
      const remain = getDaysCountToEndDate(new Date(period));
      return remain < 0 ? '期限切れ' : `残り ${remain} 日`
    },
    formatDate(date: string, fmt: string): string {
      return moment(date).format(fmt)
    },
    lastUpdate: function(date: Date) {
      moment.locale( 'ja' );
      return moment(date).fromNow();
    },
  }
})
